<script>
  /**
   * @type {import("../../../Script/document".bulkDocument)}
   */
  export let document
</script>

{#if !document.isEmailFailed}
  <div style="background: {!document.emailState ? '#F9E0C2' : '#C2FFE9'};color: {!document.emailState ? '#EA9633' : '#22C55e'}" class="flex w-full items-center gap-3 rounded-md px-2 py-3 text-base font-medium">
    {#if !document.emailState}
      <div class="relative flex h-10 w-10 flex-shrink-0 items-center justify-center">
        <div style="border-color: {!document.emailState ? '#EA9633' : '#22C55e'}" class="absolute flex h-12 w-12 animate-spin rounded-full border-t-[3px] bg-transparent" />
        <div>
          <i class="fa-solid fa-file" />
        </div>
      </div>
    {:else}
      <div class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-[#22C55E] text-lg text-white">
        <i class="fa-solid fa-envelope-circle-check" />
      </div>
    {/if}

    <div class="w-3/5 truncate text-base font-medium">
      {!document.emailState ? `Generating Email for ` : `Sent Email to`}
      <strong class={document.emailState ? `text-green-900` : `text-orange-900`}>{document.recName}</strong>
    </div>
  </div>
{:else}
  <div style="background: #f8d7da;color: #721c24" class="flex w-full items-center gap-3 rounded-md px-2 py-3 text-base font-medium">
    <div class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-red-500 text-lg text-white">
      <i class="fa-solid fa-triangle-exclamation" />
    </div>

    <div class="flex w-3/5 items-center gap-3 text-base font-medium">
      <h1 class="truncate">
        Document of <strong class="text-[#491217]">{document.recName}</strong>
        failed
      </h1>
      <button data-tooltip={document.errorMsg} tooltip-position="top">
        <i class="fa-solid fa-circle-info fa-lg text-[#491217]" />
      </button>
    </div>
  </div>
{/if}
